<div
  [class.--mobile-view-card]="showMobileViewCard"
  [class.--clickable]="documentType === 'image' && !isLoadingPreview"
  [class.--loading]="isLoadingPreview"
  class="document-preview-card"
  (click)="previewImageFile()"
>
  <div [tippy]="documentName" class="document-preview-card__image">
    @if (isLoadingPreview) {
      <div class="spinner-container">
        <div class="spinner"></div>
      </div>
    } @else {
      <app-icon [iconName]="'document-' + documentType" [size]="showMobileViewCard ? '32px' : '48px'"></app-icon>
    }
  </div>
  <div class="document-preview-card__content">
    <div [tippy]="documentName" class="document-preview-card__content__file-name">
      <span>{{ documentNameWithoutExtension | humanize | truncateText: 40 }}</span>
      @if (showMobileViewCard) {
        <span class="date">{{ document.createdAt | date: 'dd.MM.yyyy' : 'UTC' }}</span>
      }
    </div>
    <div class="document-preview-card__content__actions">
      <app-icon
        [iconName]="showMobileViewCard ? 'v-ellipsis' : 'h-ellipsis'"
        [size]="showMobileViewCard ? '18px' : '24px'"
        [tippy]="menu"
        className="popper-menu"
        placement="bottom-start"
        variation="popper"
        [zIndex]="1"
        (click)="$event.stopPropagation()"
      ></app-icon>
      @if (!showMobileViewCard) {
        <p class="date">
          <span>{{ document.createdAt | date: 'dd.MM.yyyy' : 'UTC' }}</span>
        </p>
      }
    </div>
  </div>
</div>

<ng-template #menu let-data="data" let-hide>
  <div class="popper-menu-content" style="width: 235px">
    <ul>
      @if (documentType === 'image') {
        <li (click)="previewImageFile(); hide()" [class.disabled]="isLoadingPreview">
          <app-icon iconName="eye-open"></app-icon>
          <label translate>Preview Image</label>
        </li>
      }

      @if (canMove) {
        @if (document.category !== DocumentCategory.PERSONAL && canMove) {
          <li (click)="moveFileTo(DocumentCategory.PERSONAL); hide()">
            <app-icon iconName="forward"></app-icon>
            <label translate>Move to My Documents</label>
          </li>
        }
        @if (document.category !== DocumentCategory.CLUBS && canMove) {
          <li (click)="moveFileTo(DocumentCategory.CLUBS); hide()">
            <app-icon iconName="forward"></app-icon>
            <label translate>{{ isHeadlineEnterprise ? 'Move to Corporate Documents' : 'Move to Club Documents' }}</label>
          </li>
        }
        @if (document.category !== DocumentCategory.CURRENT_STATUSES && canMove) {
          <li (click)="moveFileTo(DocumentCategory.CURRENT_STATUSES); hide()">
            <app-icon iconName="forward"></app-icon>
            <label translate>{{ isHeadlineEnterprise ? 'Move to Corporate Philosophy' : 'Move to Current Statuses' }}</label>
          </li>
        }
        @if (document.category !== DocumentCategory.ARCHIVE && canMove) {
          <li (click)="moveFileTo(DocumentCategory.ARCHIVE); hide()">
            <app-icon iconName="forward"></app-icon>
            <label translate>Move to Archived</label>
          </li>
        }
      }

      <ng-container>
        <li (click)="downloadFile(); hide()" [class.disabled]="isDownloadingState">
          <app-icon iconName="download"></app-icon>
          <label translate>Download File</label>
        </li>
      </ng-container>

      @if (canDelete) {
        <li (click)="deleteFile(); hide()">
          <app-icon iconName="trash"></app-icon>
          <label translate>Delete File</label>
        </li>
      }
    </ul>
  </div>
</ng-template>
